// @ts-nocheck
(function(){
  function syncDocumentPause(){
    var hidden = document.visibilityState === 'hidden';
    document.querySelectorAll('.bento-crossfade').forEach(function(root){
      root.classList.toggle('is-document-hidden', hidden);
    });
  }

  function observeVisibility(){
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        entry.target.classList.toggle('is-out-of-view', !entry.isIntersecting);
      });
    }, {
      threshold: 0.15,
    });

    document.querySelectorAll('.bento-crossfade').forEach(function(root){
      observer.observe(root);
    });
  }

  function toggle(e){
    var btn = e.target && e.target.closest && e.target.closest('.bento-cf-toggle');
    if(!btn) return;
    var targetId = btn.getAttribute('data-target');
    if(!targetId) return;
    var root = document.getElementById(targetId);
    if(!root) return;
    var pressed = btn.getAttribute('aria-pressed') === 'true';
    var next = !pressed;
    btn.setAttribute('aria-pressed', String(next));
    btn.setAttribute('aria-label', next ? 'Play' : 'Pause');
    if(next){
      // Paused state
      root.classList.add('is-paused');
    } else {
      // Playing state
      root.classList.remove('is-paused');
    }
  }
  document.addEventListener('click', toggle);
  document.addEventListener('visibilitychange', syncDocumentPause);

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      observeVisibility();
      syncDocumentPause();
    }, { once: true });
  } else {
    observeVisibility();
    syncDocumentPause();
  }
})(); 